import { useStaticQuery, graphql } from "gatsby"

export const useFeaturedWork = () => {
  const data = useStaticQuery(
    graphql`
      query GetFeaturedWork {
        allWpWork(filter: {workFields: {featuredItem: {eq: true}}}) {
          edges {
            node {
              title
              slug
              id
              workFields {
                tileImage
                featuredItem
              }
            }
          }
        }
      }
    `
  )
  return data.allWpWork.edges;
}